import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import { getLanguage } from '../../../features/app/selectors';
import { PrepAndProdImageThumbnail } from '../../../features/PpiContainer/constants';
import imageType from '../../../types/image';
import ImageWithDropzone from '../../Image/ImageWithDropzone';
import TextEditor from 'components/common/TextEditor';

const StepContent = ({
  stepData,
  image,
  number,
  onChangeImage,
  onChangeData,
  classes
}) => {
  const language = useSelector(getLanguage);
  const localizedInstructionField = `info.${language}.instruction`;
  const instruction = _.get(stepData, localizedInstructionField, '');
  const handleEditorChange = content => {
    onChangeData(localizedInstructionField, content);
  };
  return (
    <>
      <ImageWithDropzone
        image={image}
        thumbnailHeight={PrepAndProdImageThumbnail.Height}
        thumbnailWidth={PrepAndProdImageThumbnail.Width}
        onUploadImage={onChangeImage}
      />
      <CardContent>
        {/* <TextField
          value={instruction}
          multiline
          rows={6}
          variant="filled"
          placeholder="Instructions for the step"
          InputProps={{
            classes: {
              root: classes.inputRoot
            }
          }}
          inputProps={{
            tabIndex: number
          }}
          fullWidth
          onChange={event => {
            onChangeData(localizedInstructionField, event.target.value);
          }}
        /> */}
        <TextEditor
          value={instruction}
          onChange={content => onChangeData(localizedInstructionField, content)}
          charLimit={300} // Set character limit
        />
      </CardContent>
    </>
  );
};

StepContent.propTypes = {
  stepData: PropTypes.object.isRequired,
  image: imageType,
  number: PropTypes.number,
  onChangeImage: PropTypes.func,
  onChangeData: PropTypes.func,
  classes: PropTypes.object
};

export default StepContent;
